package or.garden.manager.features.seeds.components

import androidx.compose.runtime.Composable
import or.garden.manager.domain.model.SeedData
import org.jetbrains.compose.web.dom.*

@Composable
fun WebSeedCard(
    seed: SeedData,
    onEdit: () -> Unit,
    onDelete: () -> Unit
) {
    Div({
        classes(
            "bg-white", "rounded-3xl", "p-6", "shadow-sm", "border", "border-gray-100", "hover:shadow-md", "transition-all"
        )
    }) {
        Div({ classes("flex", "justify-between", "items-start", "mb-4") }) {
            Div({
                classes(
                    "w-12", "h-12", "bg-emerald-50", "rounded-2xl", "flex", "items-center", "justify-center"
                )
            }) {
                I({ classes("fas", "fa-seedling", "text-emerald-600", "text-xl") })
            }

            Div({ classes("flex", "gap-2") }) {
                Button({
                    classes(
                        "w-10", "h-10", "rounded-xl", "bg-gray-50", "text-gray-400", "hover:text-emerald-600", "hover:bg-emerald-50", "transition-all"
                    )
                    onClick { onEdit() }
                }) { I({ classes("fas", "fa-edit") }) }

                Button({
                    classes(
                        "w-10", "h-10", "rounded-xl", "bg-gray-50", "text-gray-400", "hover:text-red-600", "hover:bg-red-50", "transition-all"
                    )
                    onClick { onDelete() }
                }) { I({ classes("fas", "fa-trash-alt") }) }
            }
        }

        H3({ classes("text-xl", "font-bold", "text-gray-900") }) { Text(seed.name) }
        if (!seed.latinName.isNullOrBlank()) {
            P({ classes("text-sm", "text-gray-500", "italic", "mb-4") }) { Text(seed.latinName!!) }
        }

        Div({ classes("grid", "grid-cols-2", "gap-4", "mb-6") }) {
            SeedStat(
                "Tip", when (seed.type) {
                    "late" -> "Kasna"; "medium" -> "Srednja"; else -> "Rana"
                }
            )
            SeedStat("Hibrid", if (seed.hybrid) "Da" else "Ne")
            if (seed.harvestTime != null) SeedStat("Berba", "${seed.harvestTime} dana")
            if (!seed.seedlingDate.isNullOrBlank()) SeedStat("Rasad (mjeseci)", seed.seedlingDate!!)
        }

        if (seed.photo != null || seed.backPhoto != null) {
            Div({ classes("flex", "gap-2", "overflow-x-auto", "pb-2") }) {
                if (seed.photo != null) {
                    Img(
                        src = seed.photoUrl()!!,
                        attrs = {
                            classes("h-24", "rounded-xl", "object-cover", "border", "border-gray-100")
                        })
                }
                if (seed.backPhoto != null) {
                    Img(
                        src = seed.backPhotoUrl()!!,
                        attrs = {
                            classes("h-24", "rounded-xl", "object-cover", "border", "border-gray-100")
                        })
                }
            }
        }
    }
}

@Composable
fun SeedStat(label: String, value: String) {
    Div {
        Span({
            classes("text-[10px]", "uppercase", "tracking-wider", "font-bold", "text-gray-400", "block")
        }) { Text(label) }
        Span({ classes("text-sm", "font-bold", "text-gray-700") }) { Text(value) }
    }
}
